export const SUBSCRIPTION_TABS = [
  {
    value: "current",
    displayName: "Current",
  },
  {
    value: "all",
    displayName: "All",
  },
];

export const paymentTermFrequencyOptions = [
  { value: "weeks", name: "Week" },
  // { value: "fortnight", name: "Fortnight" },
  { value: "months", name: "Month" },
  { value: "years", name: "Years" },
  // { value: "ongoing", name: "Ongoing" },
];

export const paymentFrequencyOptions = [
  { value: "week", name: "Week" },
  { value: "fortnight", name: "Fortnight" },
  { value: "month", name: "Month" },
];

export const sessionsFrequencyOptions = [
  { value: "week", name: "Week" },
  { value: "fortnight", name: "Fortnight" },
  { value: "month", name: "Month" },
];

export const paymentMethodOptions = [
  { value: "automatic", name: "Automatic" },
  { value: "manual", name: "Manual" },
];

export const paymentTypeOptions = [
  { value: "eway", name: "eWay" },
  { value: "cash", name: "Cash" },
  { value: "bank_transfer", name: "Bank Transfer" },
  { value: "other", name: "Other" },
];

export const daysOfWeek = [
  { label: "Mon", value: "monday" },
  { label: "Tue", value: "tuesday" },
  { label: "Wed", value: "wednesday" },
  { label: "Thu", value: "thursday" },
  { label: "Fri", value: "friday" },
  { label: "Sat", value: "saturday" },
  { label: "Sun", value: "sunday" },
];

export const recurrenceFrequencyOptions = [
  { value: "daily", name: "Daily" },
  { value: "weekly", name: "Weekly" },
  { value: "monthly", name: "Monthly" },
];
export const SESSION_STATUSES = {
  COMPLETE_SESSION: "completed",
  COMPLETE_LATER: "completeLater",
  HAND_OFF: "hand-off",
};

export const BOOKING_TYPE = {
  SERVICE: "service",
};

export const SEX_OPTIONS = [
  { value: "male", name: "Male" },
  { value: "female", name: "Female" },
  { value: "other", name: "Other" },
];

export const INACTIVE = "inactive";
